import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

const PLAYBACK_RATES = [1, 1.5, 2];

const PlaybackRateChangeButton = ({ onPlaybackRateChange }) => {
  const [playbackRateIndex, setPlaybackRateIndex] = useState(0);

  const onRateChange = useCallback(() => {
    const nextIndex = playbackRateIndex + 1 >= PLAYBACK_RATES.length ? 0 : playbackRateIndex + 1;
    setPlaybackRateIndex(nextIndex);

    onPlaybackRateChange(PLAYBACK_RATES[nextIndex]);
  }, [onPlaybackRateChange, playbackRateIndex]);

  return (
    <button
      type="button"
      className="bg-blue-500 rounded-full text-white px-3 py-1.5 text-center text-xs font-semibold w-12 whitespace-nowrap"
      onClick={onRateChange}
    >
      {PLAYBACK_RATES[playbackRateIndex]}x
    </button>
  );
};

PlaybackRateChangeButton.propTypes = {
  onPlaybackRateChange: PropTypes.func.isRequired,
};

export default PlaybackRateChangeButton;
